/* eslint-disable @typescript-eslint/no-unused-vars */
import { FunctionComponent, ReactElement, useContext } from 'react';
import styled from 'styled-components';
import { NumericInput, RentAmountRules } from '../../components/DesignSystem';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { FormText, FormTips } from '../../styles/TypoStyle';
const InfoText = styled.div`
  border-radius: 4px;
  background-color: rgb(229, 245, 253);
  color: #4a4a4a;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
  padding: 16px;
  margin-top: 16px;
  font-family: 'Open Sans';
`;

const Container = styled.div`
  selected-button {
    max-width: 30%;
    min-width: 23px;
  }
`;
const ContainerConsent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;
const ConsentDetail = styled(FormTips)`
  margin-left: 32px;
  margin-top: 4px;
`;
const Consent = styled(FormText)``;

const Depenses: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { housing, budget },
    dispatch,
  } = useContext(store);

  const onRentAmountChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    // if (budget?.expenses?.rentAmount && budget?.expenses?.rentAmount <= 30000) {
    dispatch(
      updateStore({
        budget: { expenses: { rentAmount: Number(String(e.currentTarget?.value).replace(/\s/g, '')) } },
      }),
    );
    // }
  };

  const onConsentChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ budget: { expenses: { acceptTermContract: (e as CustomEvent)?.detail?.value } } }));
  };

  return (
    <>
      <Container>
        <NumericInput
          with-reset
          class="to-validate trackable-blur"
          required
          label="Loyer / remboursement résidence principale"
          maxLength="4"
          placeholder="Somme totale"
          value={housing?.housingCode === 'L' ? budget?.expenses?.rentAmount : 0}
          onLetterChanged={onRentAmountChange}
          onInputChange={onRentAmountChange}
          replacement={RentAmountRules.replacement}
          customValidityPattern={RentAmountRules.customValidityPattern}
        ></NumericInput>
        {/* <ContainerConsent>
        <BaseCheckbox
          class="to-validate trackable-checked"
          onCheckedChanged={onConsentChange}
          checked={budget?.expenses?.acceptTermContract || null}
          error-message="Votre consentement est obligatoire pour continuer la demande."
          id="Attestation"
        >
          <Consent>
            Vous attestez que le crédit sollicité n’a pas pour objet le remboursement de crédits et/ou dettes en cours.{' '}
          </Consent>
        </BaseCheckbox>
        <ConsentDetail>
          À défaut, si votre demande concerne un rachat de crédits, merci de contacter notre centre de relation client
          au 09 69 32 75 02.
        </ConsentDetail>
      </ContainerConsent> */}
        <InfoText>
          <span
            rv-text="model.app.rcsi.RCSI.RCSI_infosPerso_LIB060"
            rv-aria-label="model.app.rcsi.RCSI.RCSI_infosPerso_LIB060"
            aria-label="Renseignez vos revenus, ainsi que celui de votre conjoint, avant prélèvement à la source."
          >
            Renseignez le montant du loyer si vous êtes locataire, autrement, choisissez "Aucun"
          </span>
        </InfoText>
      </Container>
    </>
  );
};

export default Depenses;
